export default __webpack_public_path__ + "static/media/misc-closetA-2048w.3551300d.png";